// Lib
import React from 'react';
import { BarChart3, Gem, Search, Send, Wallet, Workflow } from 'lucide-react';

// Components
import { SelectableCard } from './SelectableCard';

// Types
import type { OrganizationAnswers } from '../../model/useCreateOrganization';

interface GoalsSelectorProps {
  answers: OrganizationAnswers;
  onChange: (name: string, value: string | string[]) => void;
}

const GOAL_OPTIONS: { value: string; label: string; Icon: typeof Gem }[] = [
  {
    value: 'managing sales pipelines',
    label: 'Managing sales pipelines',
    Icon: Gem,
  },
  {
    value: 'engagement assessment',
    label: 'Engagement assessment',
    Icon: BarChart3,
  },
  { value: 'process automation', label: 'Process automation', Icon: Workflow },
  {
    value: 'integrate with social platforms',
    label: 'Integrate with social platforms',
    Icon: Send,
  },
  {
    value: 'manage budgets and payments',
    label: 'Manage budgets and payments',
    Icon: Wallet,
  },
  {
    value: 'find relevant influencers',
    label: 'Find relevant influencers',
    Icon: Search,
  },
];

export const GoalsSelector: React.FC<GoalsSelectorProps> = ({
  answers,
  onChange,
}) => {
  const toggleGoal = (value: string) => {
    onChange(
      'goals',
      answers?.goals?.includes(value)
        ? answers.goals.filter((item) => item !== value)
        : [...answers.goals, value],
    );
  };

  return (
    <div className="mb-2 grid grid-cols-2 gap-2">
      {GOAL_OPTIONS.map(({ value, label, Icon }) => (
        <SelectableCard
          key={value}
          active={Boolean(answers?.goals?.includes(value))}
          onClick={() => toggleGoal(value)}
          className="w-full"
        >
          <Icon className="size-5 shrink-0 text-foreground" />
          <p className="text-sm text-foreground">{label}</p>
        </SelectableCard>
      ))}
    </div>
  );
};
